(function () {
  const section_instances = new Map();

  function set_video_controls(video, show) {
    if (!video) return;

    if (show) {
      video.setAttribute("controls", "");
      video.classList.add("is-controls-visible");
      return;
    }

    video.removeAttribute("controls");
    video.classList.remove("is-controls-visible");
  }

  function pause_all_videos(section_el) {
    section_el.querySelectorAll("[data-pvcf-video]").forEach((video) => {
      video.pause();
      set_video_controls(video, false);
    });
  }

  function sync_active_video_controls(section_el, swiper) {
    if (!swiper) return;

    const active_slide = swiper.slides[swiper.activeIndex];
    if (!active_slide) return;

    section_el.querySelectorAll("[data-pvcf-video]").forEach((video) => {
      set_video_controls(video, active_slide.contains(video));
    });
  }

  function play_active_video(section_el, swiper) {
    if (!swiper) return;

    const active_slide = swiper.slides[swiper.activeIndex];
    if (!active_slide) return;

    pause_all_videos(section_el);

    const active_video = active_slide.querySelector("[data-pvcf-video]");
    if (!active_video) return;

    set_video_controls(active_video, true);

    const play_promise = active_video.play();
    if (play_promise && typeof play_promise.catch === "function") {
      play_promise.catch(() => {});
    }
  }

  const OVERLAY_OPACITIES_BY_DISTANCE = [0, 0.6, 0.85, 0.95];

  function get_overlay_opacity_by_distance(distance) {
    if (distance <= 0) return OVERLAY_OPACITIES_BY_DISTANCE[0];
    if (distance < OVERLAY_OPACITIES_BY_DISTANCE.length) {
      return OVERLAY_OPACITIES_BY_DISTANCE[distance];
    }
    return OVERLAY_OPACITIES_BY_DISTANCE[OVERLAY_OPACITIES_BY_DISTANCE.length - 1];
  }

  function update_slide_overlays(swiper) {
    swiper.slides.forEach((slide) => {
      const overlay = slide.querySelector(".p-video-cf__video-overlay");
      if (!overlay) return;

      slide.style.opacity = "";
      slide.style.pointerEvents = "";

      const distance = Math.round(Math.abs(slide.progress || 0));
      overlay.style.opacity = String(get_overlay_opacity_by_distance(distance));
    });
  }

  function get_real_slide_index(section_el, block_id) {
    const slides = section_el.querySelectorAll(
      ".p-video-cf__slide:not(.p-video-cf__slide--clone)[data-block-id]"
    );
    return Array.from(slides).findIndex((slide) => slide.dataset.blockId === block_id);
  }

  function remove_infinite_clones(swiper_el) {
    if (!swiper_el) return;
    swiper_el.querySelectorAll(".p-video-cf__slide--clone").forEach((slide) => {
      slide.remove();
    });
  }

  function setup_infinite_clones(wrapper) {
    const originals = Array.from(wrapper.querySelectorAll(".p-video-cf__slide:not(.p-video-cf__slide--clone)"));
    const count = originals.length;
    if (count <= 1) return count;

    originals.forEach((slide) => {
      const clone = slide.cloneNode(true);
      clone.classList.add("p-video-cf__slide--clone");
      clone.removeAttribute("id");
      wrapper.appendChild(clone);
    });

    for (let i = originals.length - 1; i >= 0; i -= 1) {
      const clone = originals[i].cloneNode(true);
      clone.classList.add("p-video-cf__slide--clone");
      clone.removeAttribute("id");
      wrapper.insertBefore(clone, wrapper.firstChild);
    }

    return count;
  }

  function fix_infinite_position(swiper, slide_count) {
    const index = swiper.activeIndex;

    if (index >= slide_count * 2) {
      swiper.slideTo(index - slide_count, 0, false);
      return;
    }

    if (index < slide_count) {
      swiper.slideTo(index + slide_count, 0, false);
    }
  }

  function bind_navigation(swiper, prev_el, next_el) {
    if (!prev_el || !next_el) return null;

    const on_prev = (event) => {
      event.preventDefault();
      swiper.slidePrev();
    };

    const on_next = (event) => {
      event.preventDefault();
      swiper.slideNext();
    };

    prev_el.addEventListener("click", on_prev);
    next_el.addEventListener("click", on_next);

    return () => {
      prev_el.removeEventListener("click", on_prev);
      next_el.removeEventListener("click", on_next);
    };
  }

  function sync_variant_from_main_form(section_el) {
    const variant_input = section_el.querySelector("[data-pvcf-variant-input]");
    if (!variant_input) return;

    const main_inputs = Array.from(
      document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]')
    ).filter((input) => !section_el.contains(input));

    if (!main_inputs.length || !main_inputs[0].value) return;

    variant_input.value = main_inputs[0].value;
    variant_input.disabled = false;
  }

  function bind_variant_sync(section_el) {
    const variant_input = section_el.querySelector("[data-pvcf-variant-input]");
    if (!variant_input) return null;

    const price_el = section_el.querySelector("[data-pvcf-product-price]");
    const add_btn = section_el.querySelector("[data-pvcf-add-btn]");

    const update_from_variant = (variant) => {
      if (!variant) return;

      variant_input.value = variant.id;
      variant_input.disabled = false;

      if (price_el && typeof formatMoney === "function") {
        price_el.textContent = formatMoney(variant.price);
      }

      if (add_btn) {
        add_btn.disabled = !variant.available;
      }
    };

    const on_variant_change = (event) => {
      const variant_selects = event.target.closest("variant-selects");
      if (!variant_selects || !variant_selects.currentVariant) return;
      update_from_variant(variant_selects.currentVariant);
    };

    sync_variant_from_main_form(section_el);
    document.addEventListener("change", on_variant_change);

    return () => {
      document.removeEventListener("change", on_variant_change);
    };
  }

  function destroy_section(section_id) {
    const entry = section_instances.get(section_id);
    if (!entry) return;

    if (entry.unbind_nav) {
      entry.unbind_nav();
    }
    if (entry.unbind_variant) {
      entry.unbind_variant();
    }
    if (entry.swiper) {
      entry.swiper.destroy(true, true);
    }

    remove_infinite_clones(entry.section_el.querySelector("[data-pvcf-swiper]"));
    pause_all_videos(entry.section_el);
    section_instances.delete(section_id);
  }

  function create_section(section_el) {
    if (typeof window.Swiper !== "function") return;

    const section_id = section_el.dataset.sectionId;
    if (!section_id) return;

    destroy_section(section_id);

    const unbind_variant = bind_variant_sync(section_el);

    const swiper_el = section_el.querySelector("[data-pvcf-swiper]");
    const wrapper = swiper_el && swiper_el.querySelector(".swiper-wrapper");
    const prev_el = section_el.querySelector("[data-pvcf-prev]");
    const next_el = section_el.querySelector("[data-pvcf-next]");
    if (!swiper_el || !wrapper) {
      section_instances.set(section_id, {
        section_el,
        unbind_variant
      });
      return;
    }

    remove_infinite_clones(swiper_el);

    const initial_slide = Number(section_el.dataset.initialSlide || 0);
    const enable_continuous = section_el.dataset.loop === "true";
    const space_between = Number(section_el.dataset.spaceBetween || 0);
    const space_between_m = Number(section_el.dataset.spaceBetweenM || 8);
    const stretch = Number(section_el.dataset.stretch || 12);
    const stretch_m = Number(section_el.dataset.stretchM || 8);
    const depth = Number(section_el.dataset.depth || 180);
    const modifier_raw = Number(section_el.dataset.modifier || 18);
    const modifier = modifier_raw / 10;

    let slide_count = wrapper.querySelectorAll(".p-video-cf__slide:not(.p-video-cf__slide--clone)").length;
    if (slide_count === 0) {
      section_instances.set(section_id, {
        section_el,
        unbind_variant
      });
      return;
    }

    let enable_infinite = enable_continuous && slide_count > 1;
    if (enable_infinite) {
      slide_count = setup_infinite_clones(wrapper);
    }

    const safe_initial = Math.min(Math.max(initial_slide, 0), slide_count - 1);
    const start_index = enable_infinite ? slide_count + safe_initial : safe_initial;

    const coverflow_effect = {
      rotate: 0,
      stretch: stretch,
      depth: depth,
      modifier: modifier,
      slideShadows: false
    };

    const coverflow_effect_m = {
      rotate: 0,
      stretch: stretch_m,
      depth: depth,
      modifier: modifier,
      slideShadows: false
    };

    const swiper = new window.Swiper(swiper_el, {
      effect: "coverflow",
      centeredSlides: true,
      loop: false,
      rewind: false,
      grabCursor: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      speed: 600,
      initialSlide: start_index,
      slidesPerView: "auto",
      spaceBetween: space_between,
      coverflowEffect: coverflow_effect,
      breakpoints: {
        0: {
          spaceBetween: space_between_m,
          coverflowEffect: coverflow_effect_m
        },
        768: {
          spaceBetween: space_between,
          coverflowEffect: coverflow_effect
        }
      },
      on: {
        init() {
          update_slide_overlays(this);
          sync_active_video_controls(section_el, this);
          play_active_video(section_el, this);
        },
        setTranslate() {
          update_slide_overlays(this);
        },
        slideChange() {
          sync_active_video_controls(section_el, this);
        },
        slideChangeTransitionEnd() {
          if (enable_infinite) {
            fix_infinite_position(this, slide_count);
          }
          update_slide_overlays(this);
          play_active_video(section_el, this);
        }
      }
    });

    const unbind_nav = bind_navigation(swiper, prev_el, next_el);

    section_instances.set(section_id, {
      swiper,
      section_el,
      unbind_nav,
      unbind_variant,
      slide_count,
      enable_infinite
    });
  }

  function init_all_sections() {
    document.querySelectorAll("[data-pvcf-section]").forEach((section_el) => {
      create_section(section_el);
    });
  }

  function wait_for_swiper(retry = 0) {
    if (typeof window.Swiper === "function") {
      init_all_sections();
      return;
    }
    if (retry > 20) return;
    setTimeout(() => wait_for_swiper(retry + 1), 120);
  }

  function on_block_select(event) {
    const block_el = event.target && event.target.closest ? event.target.closest(".p-video-cf__slide") : null;
    if (!block_el) return;

    const section_el = block_el.closest("[data-pvcf-section]");
    if (!section_el) return;

    const entry = section_instances.get(section_el.dataset.sectionId);
    if (!entry || !entry.swiper) return;

    const block_id = block_el.dataset.blockId;
    if (!block_id) return;

    const target_index = get_real_slide_index(section_el, block_id);
    if (target_index < 0) return;

    const slide_to_index = entry.enable_infinite
      ? entry.slide_count + target_index
      : target_index;

    entry.swiper.slideTo(slide_to_index);
  }

  document.addEventListener("DOMContentLoaded", () => {
    wait_for_swiper();
  });

  document.addEventListener("shopify:section:load", (event) => {
    const section_el = event.target && event.target.closest ? event.target.closest("[data-pvcf-section]") : null;
    if (!section_el) return;
    wait_for_swiper();
  });

  document.addEventListener("shopify:section:unload", (event) => {
    const section_el = event.target && event.target.closest ? event.target.closest("[data-pvcf-section]") : null;
    if (!section_el) return;
    destroy_section(section_el.dataset.sectionId);
  });

  document.addEventListener("shopify:block:select", on_block_select);
})();
